import { render, staticRenderFns } from "./PrimaryList.vue?vue&type=template&id=099bd8ef&"
import script from "./PrimaryList.vue?vue&type=script&lang=js&"
export * from "./PrimaryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports